// @general/auth - frontend surface.
//
// Exposes routes and the session store. The shell mounts the routes; it does not
// know what is inside them, which is the same contract a business module gets.

export { useAuthStore } from './store'
export { authApi } from './api'
// Para el armazón: lo que tiene que pasar antes de revocar la sesión (la baja
// del push, que es de notifications y no de auth).
export { onBeforeLogout } from './sessionEvents.mjs'

export const routes = [
  {
    path: '/login',
    name: 'login',
    component: () => import('./views/LoginView.vue'),
    meta: { public: true, layout: 'auth' },
  },
  {
    path: '/forgot-password',
    name: 'forgot-password',
    component: () => import('./views/ForgotPasswordView.vue'),
    meta: { public: true, layout: 'auth' },
  },
  {
    path: '/reset-password',
    name: 'reset-password',
    component: () => import('./views/ResetPasswordView.vue'),
    meta: { public: true, layout: 'auth' },
  },
  {
    path: '/profile',
    name: 'profile',
    component: () => import('./views/ProfileView.vue'),
    meta: { title: 'profile.title' },
  },
]

export default { routes }
